/**
 * Portal 路由建议客户端 — REQ-20260514-0005
 *
 * web (admin) 端镜像，与 web-mall/src/api/portalSuggest.ts 对等。
 * 接口失败（5xx / 超时 / 网络错）时退化为 "stay" 决策：保持在 web，不强行跳走。
 */
import request from '@/utils/request';

export interface PortalDecision {
  target: 'admin' | 'mall' | 'stay';
  url: string;
  reason: string;
}

interface BackendResponse {
  target?: string;
  url?: string;
  reason?: string;
}

const SUGGEST_TIMEOUT_MS = 2000;

/**
 * 拿到 portal 决策。优先后端接口，失败退化为 stay（让 web 继续渲染）。
 */
export async function getPortalSuggestion(): Promise<PortalDecision> {
  try {
    const res = (await request<BackendResponse>({
      url: '/api/v1/auth/portal-suggest',
      method: 'GET',
      timeout: SUGGEST_TIMEOUT_MS,
    })) as BackendResponse;

    if (res && res.target === 'admin' && typeof res.url === 'string' && res.url) {
      return { target: 'admin', url: res.url, reason: res.reason || '后端建议 admin' };
    }
    if (res && res.target === 'mall' && typeof res.url === 'string' && res.url) {
      return { target: 'mall', url: res.url, reason: res.reason || '后端建议 mall' };
    }
    return { target: 'stay', url: '', reason: '后端响应格式异常，保持在 web' };
  } catch {
    return { target: 'stay', url: '', reason: 'portal-suggest 接口异常，保持在 web' };
  }
}
